module.exports = __webpack_public_path__ + "static/media/grapefruit-2.eee613e7.png";